import { cva } from '@/styled-system/css';

export const propertyCardActionAreaRecipe = cva({
  base: {
    gridArea: 'actions',

    /* Multiple buttons are discouraged but we'll still accommodate them */
    display: 'grid',
    gridAutoFlow: 'column',
    justifyContent: 'end',
  },
  variants: {
    appearance: {
      large: {
        blockSize: 'action.xxs',
        // line up button icons with data area text
        transform: `translate({spacing.PropertyCard.DataWrapper.large.padding.horz}, calc(-1 * {spacing.PropertyCard.DataWrapper.large.padding.top}))`,
      },
      small: {
        blockSize: 'action.xxs',
        transform: `translate({spacing.PropertyCard.DataWrapper.small.padding.horz}, calc(-1 * {spacing.PropertyCard.DataWrapper.small.padding.top}))`,
      },
      horizontal: {
        blockSize: 'action.xxs',
        transform: `translate({spacing.PropertyCard.DataWrapper.horizontal.padding.horz}, calc(-1 * {spacing.PropertyCard.DataWrapper.horizontal.padding.top}))`,
      },
    },
  },
});
